import React, { Dispatch, FC, SetStateAction } from 'react';
import { Button, FormControl, InputAdornment, TextField } from '@mui/material';
import styles from './EditableTextField.module.scss';

interface EditableTextFieldProps {
  label: string;
  value: string;
  isPersonal: boolean;
  displayedValue: string;
  portfolioValue: string;
  onValueChange:  Dispatch<SetStateAction<string>>;
  onUpdate: () => void;
  onCancel: () => void;
}

const EditableTextField: FC<EditableTextFieldProps> = ({ label, value, isPersonal, displayedValue, portfolioValue, onValueChange, onUpdate, onCancel }) => (
  <div className={styles.EditableTextField} data-testid="EditableTextField">
    <FormControl className={styles.portfolioDataFormControl}>
      <TextField
        label={label}
        value={value || ''}
        disabled={isPersonal}
        multiline={label === 'Description'}
        onChange={(e) => onValueChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button
                disabled={displayedValue === portfolioValue}
                color="error"
                onClick={() => onCancel()}
              >
                Cancel
              </Button>
              <Button
                disabled={displayedValue === portfolioValue}
                onClick={() => onUpdate()}
              >
                Update
              </Button>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  </div>
);

export default EditableTextField;
